import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import VueMeta from "vue-meta";
import { BootstrapVue } from "bootstrap-vue";
// import "./assets/css/bootstrap-dark/bootstrap-dark.css";
// import "bootstrap/dist/css/bootstrap.css";
// import "bootstrap-vue/dist/bootstrap-vue.css";
// import "./assets/css/bootstrap-dark/custom-dark.less";
import "./assets/scss/custom-bootstrap.scss";
import AsyncComputed from "vue-async-computed";
import UniqueId from "vue-unique-id";

import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faCircle,
  faPlusCircle,
  faMinusCircle,
  faEdit,
  faTrophy,
  faDiamond,
  faUserSecret,
  faTrashAlt,
  faThumbsUp,
} from "@fortawesome/pro-solid-svg-icons";
import {
  faCaretCircleUp,
  faCaretCircleDown,
  faGlobe,
  faStickyNote,
  faThumbsUp as farThumbsUp,
  faQuestionCircle,
  faComments,
  faComment,
  faLink,
  faHandPaper,
  faTrash,
  faLayerGroup,
  faExclamationTriangle,
} from "@fortawesome/pro-regular-svg-icons";
import {
  faGripLines,
  faGripLinesVertical,
  faThumbsUp as falThumbsUp,
} from "@fortawesome/pro-light-svg-icons";
import {
  FontAwesomeIcon,
  FontAwesomeLayers,
  FontAwesomeLayersText,
} from "@fortawesome/vue-fontawesome";

library.add(
  faCircle,
  faCaretCircleUp,
  faCaretCircleDown,
  faPlusCircle,
  faMinusCircle,
  faEdit,
  faTrophy,
  faDiamond,
  faUserSecret,
  faGlobe,
  faStickyNote,
  faGripLines,
  faTrashAlt,
  faGripLinesVertical,
  faThumbsUp,
  falThumbsUp,
  farThumbsUp,
  faQuestionCircle,
  faComments,
  faComment,
  faLink,
  faHandPaper,
  faTrash,
  faLayerGroup,
  faExclamationTriangle
);
Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.component("font-awesome-layers", FontAwesomeLayers);
Vue.component("font-awesome-layers-text", FontAwesomeLayersText);

Vue.use(BootstrapVue, { BToast: { toaster: "b-toaster-top-center" } });
Vue.use(AsyncComputed);
Vue.use(UniqueId);
Vue.use(VueMeta);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  beforeCreate() {
    this.$store.commit("initialiseStore");
    this.$store.dispatch("initUmDbData");
  },
  render: (h) => h(App),
}).$mount("#app");
